import React from 'react'
import { Header } from '../../styles.style'
import { UserService } from '../../../../services/user.service'

const Topo = ({ step, name }) => {
	return (
		<Header className={step === 4 ? 'hide' : null}>
			<div className="title">
				<span>Seja bem vindo, {UserService.getFirstName(name)}</span>
			</div>

			<p>
				Precisamos que você complete os dados abaixo
			</p>
		</Header>
	)
}

export default Topo
